/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import get from "lodash.get";
import PropTypes from "prop-types";
import Timeago from "react-timeago";
import { MagazineCoverImageCard } from "../../Atoms/MagazineCoverImage";
import { CollectionName } from "../../Atoms/CollectionName";
import { getTextColor, formatter } from "../../../utils/utils";
import "./magazine-editions.m.css";
import { StateProvider } from "../../SharedContext";

const MagazineEditions = ({ data = [], config = {} }) => {
  if (!data.length) return <div styleName="info">No editions found</div>;
  const {
    collectionNameBorderColor = "",
    theme = "",
    collectionNameTemplate = "",
    showRowTitle = true,
    rowTitle = "Other Editions",
    editionNameFormat = "magazineDate"
  } = config;
  const textColor = getTextColor(theme);
  let issues = data.map(issue => issue.collection);

  return (
    <div
      className="full-width-with-padding arrow-component arr-magazine-issues"
      style={{ backgroundColor: theme, color: textColor }}
      data-test-id="editions"
    >
      <div styleName={`container ${textColor}`}>
        {showRowTitle && (
          <CollectionName
            collection={issues}
            collectionNameTemplate={collectionNameTemplate}
            collectionNameBorderColor={collectionNameBorderColor}
            customCollectionName={rowTitle}
            navigate={false}
          />
        )}
        <div styleName="issues">
          {issues &&
            issues.map((issue, index) => {
              return (
                <div key={index}>
                  <MagazineCoverImageCard collection={issue} config={config} />
                  {editionNameFormat === "magazineTitle" ? (
                    <div styleName="date">{issue.name}</div>
                  ) : (
                    <Timeago styleName="date" date={get(issue, ["created-at"], "")} formatter={formatter} />
                  )}
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

MagazineEditions.propTypes = {
  data: PropTypes.array,
  config: PropTypes.shape({
    rowTitle: PropTypes.string,
    collectionNameTemplate: PropTypes.string,
    collectionNameBorderColor: PropTypes.string,
    theme: PropTypes.string,
    editionNameFormat: PropTypes.string,
    showRowTitle: PropTypes.bool
  })
};

export default StateProvider(MagazineEditions);
